import {dataRow, QuantumQuery} from '../../lib/data-types';
import {NumberFormatter} from '../../lib/formatter';
import CompareTable from './compare-table';

/**
 * This will give you a percentage comparison between two queries. Only variables with a NumberFormatter will be compared. Base query should only have 1 row to compare with.
 */

export default class BasicCompareTable extends CompareTable {

    constructor(queries: Array<QuantumQuery>, asPercentage: boolean) {
        super(queries, asPercentage);
        this.buildCompareTable();
    }

    private buildCompareTable() {
        const metadata = this._compareQueries.map(q => q.metadata).flat();
        for (const query of this._compareQueries) {
            for (const row of query.data) {
                const calculatedRow: dataRow = {};
                Object.keys(row).forEach(key => {
                    const variable = metadata.find(v => v.name === key)!;
                    if (variable.formatter instanceof NumberFormatter) {
                        const compareValue = variable.getValue(row) as number;
                        let relativityScore;
                        const baseValue = this.getBaseQueryValue(variable, 0);
                        if (baseValue)
                            relativityScore = (compareValue / baseValue) * (this._asPercentage ? 100 : 1);
                        calculatedRow[key] = relativityScore && !isNaN(relativityScore) ? relativityScore : null;
                    } else {
                        calculatedRow[key] = variable.getValue(row);
                    }
                    if (!this._compareMetadata.some(v => v.name === key))
                        this._compareMetadata.push(variable);
                });
                this._compareData.push(calculatedRow);
            }
        }
    }
}